// Production stations a recipe can be made at (Recipe dialog > Station).
// Recipes print grouped by station from the Production tab. Keep in sync
// with backend/recipes/shared/stations.ts.

export const STATIONS = ['Tumbler', 'Caramelizer', 'Kettle'] as const

export type Station = (typeof STATIONS)[number]
